import React, { Component } from 'react'
import { compose, withApollo } from 'react-apollo'
import { get, debounce, forEach } from 'lodash'
import { withRouter } from 'react-router'
import { SearchAllPatients } from '@sukiai/gql/app'
import { Search } from '@sukiai/components'
import { getFullName } from '@sukiai/utils'
import { LO_STO, ROUTES } from '../../lib'
import { getAgeAndGender } from '../../lib/util'
import loSto from '../../config/loSto'
import {
  SearchResultContainer,
  ResultNameHolder,
  ResultAdditionalContent
} from './style'

class SearchContainer extends Component {
  state = {
    loading: false,
    patients: null,
    text: '',
    hotkey: false,
    triggerToggle: false
  }

  search = debounce(text => {
    if (text.length > 0) {
      const { client } = this.props
      client.query({
        query: SearchAllPatients,
        variables: { name: text }
      }).then(({ data }) => {
        const results = this.transformData(get(data, 'searchPatients.results'))
        this.setState({
          patients: results,
          text
        })
      }).catch(err => {
        this.setState({
          patients: null,
          text
        })
        console.error('Error searching patients:', err)
      })
    } else {
      this.setState({
        patients: null,
        text
      })
    }
  }, 300)

  transformData = data => {
    const resultData = []
    forEach(data, patient => {
      const resultObj = {
        id: get(patient, 'id', null),
        content: this.getSearchResultContent(getFullName(get(patient, 'person', {})), getAgeAndGender(get(patient, 'person', {})))
      }
      resultData.push(resultObj)
    })
    return resultData
  }

  getSearchResultContent = (name, additionalContent) => {
    return (
      <SearchResultContainer>
        <ResultNameHolder data-cy='search-result-name'>{name}</ResultNameHolder>
        <ResultAdditionalContent data-cy='search-result-additional-content'>{additionalContent}</ResultAdditionalContent>
      </SearchResultContainer>
    )
  }

  goToPatient = id => {
    loSto.set(LO_STO.CURRENT_PATIENT_ID, id)
    this.props.history.push(`${ROUTES.PATIENT_NOTES}/${id}`)
  }

  render () {
    const {
      patients,
      text,
      triggerToggle
    } = this.state

    return (
      <div>
        <Search
          search={this.search}
          handleSelection={this.goToPatient}
          resultsData={patients}
          searchText={text}
          triggerToggle={triggerToggle}
          isSearchAnimatedWithIcon
        />
      </div>
    )
  }
}

export default compose(
  withRouter,
  withApollo
)(SearchContainer)
